import './js/widget-counters.js';
import './js/bs-triggers.js';
import './js/filter-form.js';

const helloWorld = () => console.log("javascript loaded!")
helloWorld();